
<div class="flex flex-col justify-center w-full mb-0">
  <div class="relative w-full mt-15 bg-session-theme-{{session()?.topic}} h-140 2xs:h-140 md:h-140 xl:h-140 2xl:h-200" >

    <div class="absolute inset-0 z-10 h-full w-full bg-theme-black bg-cover bg-center "
         [ngClass]="{'opacity-0': session()?.topic == 'lgbt_w', 'opacity-15': session()?.topic != 'lgbt_w'}"
    ></div>
    <div class="relative z-9990 w-full ml-auto mr-auto lg:w-[1024px] 2xl:w-[90rem] 2xl:pt-10 2xl:pb-10 flex flex-col
      p-3 2xs:p-5 sm-home:pl-10 2xl:pl-5 lg:pl-5   "
         [ngClass]="{'mt-[65%] xs-home:mt-[55%] 2xs:mt-[35%] sm:mt-[30%] sm-home:mt-[30%] md:mt-[25%] md-home-2:mt-[22%] lg:mt-[12%] 3xl:mt-[12%]': session()?.topic == 'lgbt_w',
                  'mt-[35%] xs-home:mt-[35%] 2xs:mt-[25%] sm:mt-[20%] sm-home:mt-[22%] md:mt-[17%] md-home-2:mt-[17%] lg:mt-[15%] 3xl:mt-[10%]': session()?.topic != 'lgbt_w'}"
    >

      <p *ngIf="session()?.topic == 'green'" class="bg-theme-green-110 text-white rounded-sm p-1 w-[150px] text-center font-bold -mt-5 sm:mt-10 lg:mt-0 lg:text-xl lg:w-[180px]">SPEED DATING</p>

      <h1 class="font-theme-source 2xs:text-4xl sm:text-4xl md:text-5xl xl:text-5xl 2xl:text-7xl font-bold text-white text-left  mt-2"
          [ngClass]="{'xs:text-2xl xs-home:text-3xl 2xs:pr-15 sm:pr-15 md:pr-5 lg: pr-5 ': session()?.topic == 'lgbt_w', 'text-3xl  pr-25 2xs:pr-55 sm:pr-25': session()?.topic != 'lgbt_w'}"
          *ngIf="topic()" [innerHTML]="topic().title">
      </h1>

      <h2 class="font-theme-source text-xl 2xs:text-2xl sm:text-2xl md:text-2xl xl:text-3xl 2xl:text-4xl font-light text-white text-left" *ngIf="topic()"
          [ngClass]="{'text-lg': session()?.topic == 'lgbt_w', 'text-xl': session()?.topic != 'lgbt_w'}"
          [innerHTML]="topic().subtitle">
      </h2>
      <h2 class="font-theme-source text-lg 2xs:text-xl sm:text-2xl md:text-2xl xl:text-2xl 2xl:text-3xl font-bold text-left mt-3 2xl:mt-10" *ngIf="session()"
          [class.text-theme-pink]="session()?.topic == 'none'" [class.text-white]="session()?.topic != 'none'"
      >
        {{session().description}}, le {{session().date | showEventDate}}
      </h2>
      <div class="w-full text-left mt-10 sm:mt-4 md:mt-10">
        <a class="color-white rounded-full p-2 text-base xs-home:text-lg xl:text-2xl font-theme-source cursor-pointer  text-white font-bold pl-5 pr-5" *ngIf="session()"
           [class.bg-theme-pink]="session()?.topic == 'none'" aria-label="Je réserve"
           [class.bg-theme-green-110]="session()?.topic == 'green'"
           [class.bg-theme-purple]="session()?.topic == 'lgbt_w'"

           [routerLink]="['/subscribe-v2', session().id, 'who']" (click)="socialTrackService.trackGAEvent('lp_click_cta_top')">
            <span>{{ label().title }}</span>
            <span class="font-light hidden xs:inline"> · {{ label().detail }}</span>
        </a>
        <p class="font-theme-source text-white text-[14px] 2xs:text-base mt-4 2xs:mt-6">+1700 célibataires ont testé, 75% ont trouvé un coup de cœur</p>
        <div *ngIf="session() && subscribedPeople()?.length >= 5 && session()?.topic != 'lgbt_w'" class="swiper people-carousel swiper-container text-white text-[14px] mb-0 w-full h-[80px]">
          <div class="swiper-wrapper" >
            <div class="swiper-slide font-theme-source mt-3" *ngFor="let subscribedPeople of subscribedPeople(); trackBy: trackById">
              <p class="font-bold">{{subscribedPeople.firstname}} ({{subscribedPeople.age}} ans) est déja inscrit(e)
                <span class="font-light" *ngFor="let hobby of subscribedPeople.hobbies; trackBy: trackByItem"> · {{hobby}}</span>
                <span class="font-light" *ngFor="let aboutMe of subscribedPeople.aboutMe; trackBy: trackByItem"> · {{aboutMe}}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="w-full bg-theme-blue ">
    <div class="w-full ml-auto mr-auto md:w-[768px] z-9994 flex flex-col pl-3 pr-3 pt-0 lg:p-0">
      <h2 class="font-theme-source text-3xl 2xs:text-4xl sm:text-5xl md:text-5xl xl:text-5xl 2xl:text-7xl font-bold text-white text-left mt-5 md:mt-10">
        Ta soirée
      </h2>
      <div class="w-full bg-white p-2 rounded-2xl mt-5 md:mt-10 flex flex-col" *ngIf="session()">
        <app-session-content [session]="session()" ></app-session-content>

        <p class="font-theme-source text-sm md:text-base mt-5 w-full text-center italic font-medium">Je choisis ma tranche d'âge de recherche maintenant 👇</p>
        <a class="mt-3 w-full font-theme-source rounded-full p-2 text-xl xl:text-2xl font-bold cursor-pointer bg-theme-yellow text-theme-black border-theme-black border-4 pl-5 pr-5 text-center" *ngIf="session()"
           [routerLink]="['/subscribe-v2', session().id, 'who']" (click)="socialTrackService.trackGAEvent('lp_click_cta_middle')" aria-label="Je réserve">
          <span *ngIf="stayingPlaces() !== 0">Je réserve</span>
          <span *ngIf="stayingPlaces() === 0">Liste d'attente</span>
        </a>
      </div>

      <div class="w-full flex flex-col mt-5 mb-5">
        <div class="block w-full text-left">
          <div class="w-full 2xs:mt-8" appDynamicScript>
            <div src="https://cdn.trustindex.io/loader.js?25f7170641133425f576196d58d" ></div>
          </div>
        </div>
        <app-match-testimony class="mt-7">
          <p>Lors de la première soirée 7 minutes pour toi que j'ai pu faire grâce à vous, j'ai fait la rencontre de Annick.<br/>
            Nous avons eu l'opportunité de nous revoir par la suite. Et une véritable histoire d'amour en a découlé.</p>
          <p class="mt-3">Je tenais à vous dire merci d'avoir rendu cela possible.</p>
          <p class="w-full text-base text-right mt-2 font-bold">
            Frédéric
          </p>
        </app-match-testimony>
        <app-match-testimony class="mt-2">
          <p>Le speed dating était tout nouveau pour moi, la soirée a débuté et je me suis vite prise au jeu. Je veux dire aux célibataires actuels qu'il faut y croire et franchir le pas.</p>
          <p>Je suis restée longtemps célibataire, le speed dating a été pour moi une vraie révélation.</p>
          <p class="w-full text-base text-right mt-2 font-bold">
            Alicia
          </p>
        </app-match-testimony>
        <app-match-testimony class="mt-2">
          <p>Je tenais à vous faire ce retour car grâce à votre événement, je ne suis plus célibataire. Un grand merci à toute l'équipe pour votre votre organisation.</p>
          <p class="w-full text-base text-right mt-2 font-bold">
            Stéphanie
          </p>
        </app-match-testimony>
        <app-session-testimonies *ngIf="session()" class="w-full mt-5 mb-10" [city]="session().cityName"></app-session-testimonies>
      </div>
    </div>
    <div class="w-full ml-auto mr-auto z-9994 flex flex-col bg-theme-black">
      <div class="flex flex-col w-full lg:w-2/3 2xl:w-1/2 lg:mt-10 lg:mb-5 lg:h-auto xl:mt-15 ml-auto mr-auto">
        <video class="w-full lg:rounded-xl " autoplay loop muted playsinline preload="none" id="welcome-video">
          <source id="source-desktop" type="video/webm" media="(min-width: 600px)" />
          <source id="source-mobile" type="video/webm" media="(max-width: 600px)" />
        </video>
      </div>
    </div>
    <div class="w-full flex flex-col bg-theme-black z-9995">
      <app-home-digits class="mt-2 2xs:mt-0 mb-10 "></app-home-digits>
      <div class="text-center mb-10">
        <a class="font-theme-source rounded-full pt-2 pb-2 text-xl xl:text-2xl cursor-pointer bg-white text-theme-black font-bold pl-5 pr-5 text-center mb-5 " *ngIf="session()"
           [routerLink]="['/subscribe-v2', session().id, 'who']" (click)="socialTrackService.trackGAEvent('lp_click_cta_event')" aria-label="Je m'inscris">
          Je m'inscris
        </a>

      </div>
      <app-home-program [showPhotos]="false" [isForWomenOnly]="session()?.topic == 'lgbt_w'" [sessionId]="session()?.id"></app-home-program>
      <app-home-faq></app-home-faq>
    </div>
  </div>
</div>
<app-page-footer></app-page-footer>
